import { allThemes, BoxProps, ColorOptions } from '@jfs/ui-new'

const styles = (breakpoint: number) => ({
  container: {
    flex: 1,
    minHeight: '100vh',
    width: '100%',
    flexDirection: 'column',
    bg: 'TRANSPARENT' as ColorOptions,
  } as BoxProps,
  twoColContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    flexWrap: 'wrap',
    overflow: 'auto',
    ph: 40,
    pb: 40,
  } as BoxProps,
  brandColumn: {
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: 460,
    marginRight: 56,
    marginBottom: 24,
  } as BoxProps,
  brandRow: {
    flexDirection: 'row',
    alignItems: 'center',
  } as BoxProps,
  brandIconBox: {
    backgroundColor: allThemes.light.colors.WHITE,
    borderRadius: 8,
    padding: 6,
  } as BoxProps,
  formContainer: {
    ph: 22,
    pv: 20,
    backgroundColor: allThemes.light.colors.WHITE,
    borderRadius: 16,
    alignSelf: 'center',
    minWidth: 320,
    maxWidth: 360,
    shadowColor: '#00000029' as ColorOptions,
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 1,
    shadowRadius: 16,
    elevation: 10,
  } as BoxProps,
  header: {
    padding: 24,
  } as BoxProps,
  form: {
    maxWidth: 400,
    minWidth: 400,
  } as BoxProps,
  forgotPassword: {
    paddingLeft: 24,
    justifyContent: 'center',
    alignItems: 'center',
    underlayColor: allThemes.light.colors.WHITE,
  } as BoxProps,
  signUp: {
    paddingHorizontal: 24,
    paddingBottom: 24,
    marginTop: 8,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  signUpText: {
    paddingLeft: 8,
    justifyContent: 'center',
    alignItems: 'center',
    underlayColor: allThemes.light.colors.WHITE,
  } as BoxProps,
  buttonBgView: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: allThemes.light.colors.PRIMARY as ColorOptions,
    underlayColor: 'PRIMARY_STORNG' as ColorOptions,
    height: 45,
    marginTop: 8,
    borderRadius: 24,
  } as BoxProps,
})

export default styles
